import { render } from "./NavbarTwo.vue?vue&type=template&id=3e815a3c&scoped=true&ts=true"
import script from "./NavbarTwo.vue?vue&type=script&lang=ts"
export * from "./NavbarTwo.vue?vue&type=script&lang=ts"

import "./NavbarTwo.vue?vue&type=style&index=0&id=3e815a3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e815a3c"]])

export default __exports__